/*
 * Gift guide page: turns the consecutive "Gift guide" sections into slides
 * laid out like magazine pages, with a contents list like a PDF's:
 * - Desktop: contents column on the left (sticky), pages to its right with
 *   the next guide peeking in; arrows either side.
 * - Phone: pages with the neighbours peeking, swipe or dots, and a
 *   "Contents" button fixed at the bottom (only while the guides are on
 *   screen) that opens the list as a sheet from the bottom.
 * Peeking guides are a way to get to them: clicking one slides it in.
 * Uses native scroll snapping; this script builds the track and keeps the
 * contents, dots, the URL (#guide-name) and the height in step with the
 * slide showing. Intro jump links go to their slide too.
 */
(function () {
  if (window.ahhGiftGuideSlider) return;
  window.ahhGiftGuideSlider = true;

  function build() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section.gg-section'));
    if (sections.length < 2 || document.querySelector('.gg-slider')) return;

    var slider = document.createElement('div');
    slider.className = 'gg-slider';
    slider.innerHTML =
      '<nav class="gg-contents gg-contents--side" aria-label="Gift guide contents">' +
        '<p class="gg-contents__label">Contents</p><ol class="gg-contents__list"></ol>' +
      '</nav>' +
      '<div class="gg-slider__main">' +
        '<div class="gg-slider__track" tabindex="0" aria-label="Gift guides"></div>' +
        '<button type="button" class="gg-slider__arrow gg-slider__arrow--prev" aria-label="Previous guide">&#8249;</button>' +
        '<button type="button" class="gg-slider__arrow gg-slider__arrow--next" aria-label="Next guide">&#8250;</button>' +
        '<div class="gg-slider__dots"></div>' +
      '</div>';
    sections[0].parentNode.insertBefore(slider, sections[0]);
    var track = slider.querySelector('.gg-slider__track');
    var dots = slider.querySelector('.gg-slider__dots');
    var sideList = slider.querySelector('.gg-contents--side .gg-contents__list');

    // Phone contents: a button fixed at the bottom and a sheet. They live on
    // <body> so the page wrapper can't clip or stack them.
    var sheet = document.createElement('div');
    sheet.className = 'gg-sheet';
    sheet.innerHTML =
      '<button type="button" class="gg-sheet__open" aria-haspopup="dialog">' +
        '<span>Contents</span><span class="gg-sheet__count"></span></button>' +
      '<div class="gg-sheet__backdrop" data-gg-sheet-close></div>' +
      '<div class="gg-sheet__panel" role="dialog" aria-modal="true" aria-label="Gift guide contents">' +
        '<div class="gg-sheet__head"><p class="gg-contents__label">Contents</p>' +
          '<button type="button" class="gg-sheet__close" data-gg-sheet-close aria-label="Close">&times;</button></div>' +
        '<ol class="gg-contents__list"></ol>' +
      '</div>';
    document.body.appendChild(sheet);
    var sheetList = sheet.querySelector('.gg-contents__list');
    var sheetCount = sheet.querySelector('.gg-sheet__count');
    document.body.classList.add('has-gg-contents');

    var intro = document.querySelector('.gg-intro__title');
    var folioTitle = (intro && intro.textContent.trim()) || 'Gift Guide';
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function nameOf(i) {
      var sub = sections[i] && sections[i].querySelector('.gg__subtitle');
      return sub ? sub.textContent.trim() : 'Guide ' + (i + 1);
    }
    function colourOf(i) {
      var g = sections[i] && sections[i].querySelector('.gg');
      return g ? getComputedStyle(g).getPropertyValue('--gg-subtitle').trim() : '';
    }

    sections.forEach(function (s) { track.appendChild(s); });

    // Full width: the theme's page wrapper has side padding that clipped the
    // page shadows. 100vw counts the desktop scrollbar, so measure instead.
    // Set on <html> so the intro can line up with the slider too.
    function fitWidth() {
      document.documentElement.style.setProperty('--gg-vw', document.documentElement.clientWidth + 'px');
    }
    fitWidth();

    var current = -1;
    var heightObserver = 'ResizeObserver' in window ? new ResizeObserver(function () { fitHeight(); }) : null;

    function contentsItem(i) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gg-contents__link';
      b.style.setProperty('--gg-c', colourOf(i) || '#2b2b2b');
      b.innerHTML = '<span class="gg-contents__num"></span><span class="gg-contents__name"></span>';
      b.children[0].textContent = pad(i + 1);
      b.children[1].textContent = nameOf(i);
      b.addEventListener('click', function () {
        closeSheet();
        go(i);
        if (slider.getBoundingClientRect().top < 0) slider.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      li.appendChild(b);
      return li;
    }

    // (Re)reads the slides from the track. The theme editor swaps a guide's
    // element for a fresh one whenever a setting changes, so the list, the
    // contents, the dots and the height watcher have to follow.
    function refresh() {
      sections = Array.prototype.slice.call(track.querySelectorAll(':scope > .shopify-section.gg-section'));
      dots.innerHTML = '';
      sideList.innerHTML = '';
      sheetList.innerHTML = '';
      if (heightObserver) heightObserver.disconnect();
      sections.forEach(function (s, i) {
        s.classList.add('gg-slide');
        if (heightObserver) heightObserver.observe(s);
        var g = s.querySelector('.gg');
        if (g) {
          var folio = g.querySelector(':scope > .gg__folio');
          if (!folio) {
            folio = document.createElement('div');
            folio.className = 'gg__folio';
            folio.setAttribute('aria-hidden', 'true');
            g.insertBefore(folio, g.firstChild);
          }
          folio.innerHTML = '<span></span><span></span>';
          folio.children[0].textContent = folioTitle;
          folio.children[1].textContent = pad(i + 1) + ' / ' + pad(sections.length);
        }
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gg-slider__dot';
        dot.setAttribute('aria-label', nameOf(i));
        dot.addEventListener('click', function () { go(i); });
        dots.appendChild(dot);
        sideList.appendChild(contentsItem(i));
        sheetList.appendChild(contentsItem(i));
      });
      if (heightObserver) heightObserver.observe(slider);
    }

    function fitHeight() {
      var s = sections[current];
      var h = s && s.isConnected ? s.offsetHeight : 0;
      track.style.height = h ? h + 'px' : '';
    }
    function idOf(i) { var g = sections[i].querySelector('.gg'); return g ? g.id : ''; }

    // Where the track scrolls to show slide i. Phones centre the page
    // (neighbours peek both sides); desktop lines it up after the contents
    // column (next guide peeks on the right). The CSS decides which.
    function targetOf(i) {
      var s = sections[i];
      if (getComputedStyle(s).scrollSnapAlign.indexOf('start') === 0) {
        return s.offsetLeft - (parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0);
      }
      return s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2;
    }

    function markCurrent(list, i) {
      Array.prototype.forEach.call(list.children, function (li, j) {
        var b = li.firstChild;
        if (j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }

    function setActive(i, updateHash) {
      if (i === current) return;
      current = i;
      Array.prototype.forEach.call(dots.children, function (d, j) {
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      markCurrent(sideList, i);
      markCurrent(sheetList, i);
      sheetCount.textContent = pad(i + 1) + ' / ' + pad(sections.length);
      sections.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      slider.querySelector('.gg-slider__arrow--prev').disabled = i === 0;
      slider.querySelector('.gg-slider__arrow--next').disabled = i === sections.length - 1;
      fitHeight();
      if (updateHash && idOf(i) && history.replaceState) history.replaceState(null, '', '#' + idOf(i));
    }

    function go(i, instant) {
      if (!sections.length) return;
      i = Math.max(0, Math.min(sections.length - 1, i));
      track.scrollTo({ left: targetOf(i), behavior: instant ? 'auto' : 'smooth' });
      setActive(i, true);
    }

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (!track.clientWidth) return;
        var best = 0, bestGap = Infinity;
        sections.forEach(function (s, j) {
          var gap = Math.abs(targetOf(j) - track.scrollLeft);
          if (gap < bestGap) { bestGap = gap; best = j; }
        });
        setActive(best, true);
      }, 80);
    });
    slider.querySelector('.gg-slider__arrow--prev').addEventListener('click', function () { go(current - 1); });
    slider.querySelector('.gg-slider__arrow--next').addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });
    // A peeking guide is a way to get to it, not to its products.
    track.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('.gg-slide');
      if (!s || s.classList.contains('is-active')) return;
      e.preventDefault();
      e.stopPropagation();
      go(sections.indexOf(s));
    }, true);

    // Phone contents sheet.
    function openSheet() { sheet.classList.add('is-open'); document.documentElement.classList.add('gg-sheet-lock'); }
    function closeSheet() { sheet.classList.remove('is-open'); document.documentElement.classList.remove('gg-sheet-lock'); }
    sheet.querySelector('.gg-sheet__open').addEventListener('click', openSheet);
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-gg-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    // The button only shows while the guides are on screen.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sheet.classList.toggle('is-near', entries[0].isIntersecting);
      }, { rootMargin: '-30% 0px -30% 0px' }).observe(slider);
    } else {
      sheet.classList.add('is-near');
    }

    function indexOfId(id) {
      for (var i = 0; i < sections.length; i++) if (idOf(i) === id) return i;
      return -1;
    }

    // Intro jump links (and any other #guide link) go to that slide.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var i = indexOfId(a.getAttribute('href').slice(1));
      if (i < 0) return;
      e.preventDefault();
      go(i);
      slider.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Theme editor: selecting a guide shows its slide; a re-rendered, added
    // or removed guide refreshes the slides and stays on screen.
    function isGuide(el) { return el && el.classList && el.classList.contains('gg-section'); }
    document.addEventListener('shopify:section:select', function (e) {
      var i = sections.indexOf(e.target);
      if (i >= 0) go(i, true);
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (!isGuide(e.target)) return;
      if (!track.contains(e.target)) track.appendChild(e.target);
      refresh();
      current = -1;
      go(Math.max(0, sections.indexOf(e.target)), true);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!isGuide(e.target)) return;
      var gone = e.target;
      setTimeout(function () {
        if (gone.isConnected) return;
        var at = current;
        refresh();
        current = -1;
        go(Math.min(at, sections.length - 1), true);
      }, 0);
    });

    refresh();

    var start = indexOfId(location.hash.slice(1));
    go(start < 0 ? 0 : start, true);
    if (start >= 0) slider.scrollIntoView({ block: 'start' });

    // Keep the current guide in place once fonts/images settle or the window
    // (or the theme editor's preview) changes width.
    var lastWidth = track.clientWidth;
    function realign() { var i = current; current = -1; go(i < 0 ? 0 : i, true); }
    window.addEventListener('resize', function () {
      fitWidth();
      if (track.clientWidth === lastWidth) return;
      lastWidth = track.clientWidth;
      realign();
    });
    window.addEventListener('load', realign);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
